let  browserInfo =  navigator.userAgent;
let  browser = '';
 if (browserInfo.includes('Chrome')) {
          browser = 'Chrome';
 }
 else if(browserInfo.includes('Safari')) {
          browser = 'Safari';
 }

if(browser == 'Safari' ){

  /* -------------------------------------------------------------------------
   * Safari fallback for the theme's <form is="product-form"> element.
   *
   * theme.js registers the add-to-cart logic as a CUSTOMIZED BUILT-IN element
   * (`customElements.define("product-form", tx, { extends: "form" })`). WebKit
   * has never shipped customized built-ins, so in Safari — desktop Safari and
   * EVERY iOS browser, since they are all WebKit — the form never upgrades and
   * nothing intercepts its submit. The code below is that missing interception.
   *
   * It is bound to `submit`, NOT to `click` on the form. A click binding was
   * the cause of the iPhone-only "tapping a bundle tier adds to cart by itself
   * and pops the cart drawer" bug: Kaching Bundles injects its tier radios
   * INSIDE this form (verified live — every .kaching-bundles__bar sits within
   * form.shopify-product-form), so any click in the form counted as an add,
   * including the programmatic ones (Kaching selecting its default tier on
   * hydration, and kaching-card-bridge.js's `label.click()` on product cards).
   * Android was unaffected only because this whole block is Safari-gated.
   *
   * The payload is now `new FormData(form)`, mirroring theme.js exactly, so
   * `quantity` and `properties[__kaching_bundles]` ride along. The old version
   * hand-picked `id` only, which stripped the bundle discount and the pack
   * size off every Safari add-to-cart.
   * ---------------------------------------------------------------------- */

  var SPINNER_HTML =
    '<span class="loader-button__text" style="height: 25px;"></span>' +
    '<span class="loader-button__loader" style="opacity:1;top:20%;left:45%;">' +
      '<div class="spinner">' +
        '<svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">' +
          '<circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>' +
        '</svg>' +
      '</div>' +
    '</span>';

  // <button is="loader-button"> does not upgrade in Safari either, so the
  // pending state has to be painted by hand.
  function showButtonLoader(form) {
    var submits = Array.prototype.filter.call(form.elements, function (el) {
      return el.type === 'submit' && !el.disabled;
    });

    var restores = submits.map(function (el) {
      var isAddButton = el.classList.contains('product-form__add-button');
      var html = isAddButton ? el.innerHTML : null;
      el.setAttribute('aria-busy', 'true');
      el.disabled = true;
      if (isAddButton) el.innerHTML = SPINNER_HTML;
      return function () {
        if (isAddButton) el.innerHTML = html;
        el.removeAttribute('aria-busy');
        el.disabled = false;
      };
    });

    return function () {
      restores.forEach(function (restore) { restore(); });
    };
  }

  $(document).on('submit', 'form.shopify-product-form', async function (e) {
    var form = this;

    // Already handled: either the element upgraded after all (a non-WebKit
    // browser, or a future WebKit that ships customized built-ins) or another
    // handler took over. Adding again here would double the line item.
    if (form.constructor !== HTMLFormElement) return;
    if (e.isDefaultPrevented()) return;

    var settings = (window.themeVariables || {}).settings || {};
    if (settings.cartType === 'page' || settings.pageType === 'cart') return;

    e.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // theme.js does this in connectedCallback; some buy-button blocks render
    // the variant input as `<input type="hidden" disabled name="id">` and a
    // disabled control is omitted from FormData.
    $(form).find('[name="id"]').prop('disabled', false);

    var restoreButton = showButtonLoader(form);

    var body = new FormData(form);
    body.append('sections', ['mini-cart']);
    body.delete('option1');
    body.delete('option2');
    body.delete('option3');

    var response, payload;
    try {
      response = await fetch(window.themeVariables.routes.cartAddUrl + '.js', {
        body: body,
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      payload = await response.json();
    } catch (error) {
      restoreButton();
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-notification:show', {
          bubbles: true,
          cancelable: true,
          detail: { status: 'error', error: '' }
        })
      );
      return;
    }

    restoreButton();

    if (!response.ok) {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-notification:show', {
          bubbles: true,
          cancelable: true,
          detail: { status: 'error', error: (payload && payload.description) || '' }
        })
      );
      return;
    }

    form.dispatchEvent(
      new CustomEvent('variant:added', {
        bubbles: true,
        detail: { variant: payload.hasOwnProperty('items') ? payload.items[0] : payload }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart-notification:show', {
        bubbles: true,
        cancelable: true,
        detail: { status: 'success', error: '' }
      })
    );

    var cart = await (await fetch(window.themeVariables.routes.cartUrl + '.js')).json();
    $('.header__secondary-links .header__icon-list .bubble-count').html(cart.item_count);

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
    );

    cart.sections = payload.sections;

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cart,
          // Don't re-open the drawer for an add made from inside the drawer.
          openMiniCart: settings.cartType === 'drawer' && form.closest('.drawer') === null
        }
      })
    );
  });

   $('body').on("click", ".cart-notification__view-cart.link", function(e){
      document.getElementById('mini-cart').open = true;
    });

  $('[aria-controls="mini-cart"]').click(function(e){
    document.getElementById('mini-cart').open = true;
    e.preventDefault();
  });

  $('[aria-controls="search-drawer"]').click(function(e){
    document.getElementById('search-drawer').open = true;
    e.preventDefault();
  });

    $('[aria-controls="header-localization-form-locale"]').click(function(e){
    document.getElementById('header-localization-form-locale').open = true;
  });

   $('[aria-controls="mobile-menu-drawer"]').click(function(e){
    document.getElementById('mobile-menu-drawer').open = true;
    e.preventDefault();
  });

  $('[is="toggle-button"]').click(function(e){
     if(document.getElementById($(this).attr('aria-controls')).open == false){
        document.getElementById($(this).attr('aria-controls')).open = true;
    }else{
       document.getElementById($(this).attr('aria-controls')).open = false;
    }
    e.preventDefault();
  });
  
}

 



// var tx = class extends HTMLFormElement {
//     constructor() {
//         super(),

//         console.log(this.textContent) // not available here, but understandable
//     } 
//    connectedCallback1() {
//       console.log('test'),
//       (this.id.disabled = !1),
//       "page" !== window.themeVariables.settings.cartType &&
//         "cart" !== window.themeVariables.settings.pageType &&
//         this.addEventListener("submit", this._onSubmit.bind(this));
//   }
//   async _onSubmit(e) {
//      console.log('sdkhsjdh');
//     if ((e.preventDefault(), !this.checkValidity())) {
//       this.reportValidity();
//       return;
//     }
//     let t = Array.from(this.elements).filter((e) => "submit" === e.type);
//     t.forEach((e) => {
//       e.setAttribute("disabled", "disabled"),
//         e.setAttribute("aria-busy", "true");
//     });
//     let i = new FormData(this);
//     console.log("product_form", i),
//       i.append("sections", ["mini-cart"]),
//       i.delete("option1"),
//       i.delete("option2"),
//       i.delete("option3");
//     let s = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
//       body: i,
//       method: "POST",
//       headers: { "X-Requested-With": "XMLHttpRequest" },
//     });
//     t.forEach((e) => {
//       e.removeAttribute("disabled"), e.removeAttribute("aria-busy");
//     });
//     let n = await s.json();
//     s.ok &&
//       (this.dispatchEvent(
//         new CustomEvent("variant:added", {
//           bubbles: !0,
//           detail: { variant: n.hasOwnProperty("items") ? n.items[0] : n },
//         })
//       ),
//       fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (e) => {
//         let t = await e.json();
//         document.documentElement.dispatchEvent(
//           new CustomEvent("cart:updated", { bubbles: !0, detail: { cart: t } })
//         ),
//           (t.sections = n.sections),
//           document.documentElement.dispatchEvent(
//             new CustomEvent("cart:refresh", {
//               bubbles: !0,
//               detail: {
//                 cart: t,
//                 openMiniCart:
//                   "drawer" === window.themeVariables.settings.cartType &&
//                   null === this.closest(".drawer"),
//               },
//             })
//           );
//       })),
//       this.dispatchEvent(
//         new CustomEvent("cart-notification:show", {
//           bubbles: !0,
//           cancelable: !0,
//           detail: {
//             status: s.ok ? "success" : "error",
//             error: n.description || "",
//           },
//         })
//       );
//   }
  
  
// }


// window.customElements.define("product-form",tx, { extends: "form" } );
